import { render, staticRenderFns } from "./can-not-remove-modal.vue?vue&type=template&id=afede182&"
import script from "./can-not-remove-modal.vue?vue&type=script&lang=js&"
export * from "./can-not-remove-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports